<div class="progress-div">
    <ul class="progress">
      <li *ngFor="let status of availableContactStatuses; index as i; first as isFirst;last as isLast" [class.middle]="i-1 == contactStatusIndex || i == contactStatusIndex || i+1 == contactStatusIndex" [class.inactive]="i > contactStatusIndex" [class.completed]="i < contactStatusIndex" [class.not-first]="!isFirst" [class.current]="i==contactStatusIndex" [class.last]="isLast" [matTooltip]="status.explanation">
        <span [class.active-status]="i == contactStatusIndex">{{status.display}}</span>
      </li>
    </ul>
  </div>
  